import { render, staticRenderFns } from "./auto.vue?vue&type=template&id=5bdfaf9e&scoped=true"
import script from "./auto.vue?vue&type=script&lang=js"
export * from "./auto.vue?vue&type=script&lang=js"
import style0 from "./auto.vue?vue&type=style&index=0&id=5bdfaf9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdfaf9e",
  null
  
)

export default component.exports